<div fxLayout="row">
    <div fxLayout="column">
        <table role="presentation">
            <tr>
                <td class="field-label">Type of Fraud:</td>
                <td class="fieldValue"><span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="rafReportObject.type"></span></td>
            </tr>
            <tr *ngIf="rafReportObject.type == 'Other'">
                <td class="field-label">Detail on Type of Fraud:</td>
                <td class="fieldValue"><span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="rafReportObject.otherTypeDetails"></span></td>                
            </tr>
            <tr>
                <td class="field-label">Description of Fraud:</td>
                <td class="fieldValue"><span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="rafReportObject.description"></span></td>
            </tr>
            <tr>
                <td class="field-label">Subject's First Name:</td>
                <td class="fieldValue">{{rafReportObject.subjectData[0].values[0].value}}</td>
            </tr>
            <tr>
                <td class="field-label">Subject's Last Name:</td>
                <td class="fieldValue">{{rafReportObject.subjectData[0].values[1].value}}</td>
            </tr>
            <tr>
                <td class="field-label">Additional Person Details:</td>
                <td class="fieldValue"><span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="rafReportObject.subjectData[0].additionalDetails"></span></td>
            </tr>
            <tr>
                <td class="field-label">Address Line One:</td>
                <td class="fieldValue"><span [innerHtml]="rafReportObject.subjectData[1].values[0].value"></span></td>
            </tr>
            <tr>
                <td class="field-label">Address Line Two:</td>
                <td class="fieldValue"><span [innerHtml]="rafReportObject.subjectData[1].values[1].value"></span></td>
            </tr>

            <tr>
                <td class="field-label">Postcode:</td>
                <td class="fieldValue"><span [innerHtml]="rafReportObject.subjectData[1].values[2].value"></span></td>
            </tr>
            <tr>
                <td class="field-label">Additional Address Details:</td>
                <td class="fieldValue"><span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="rafReportObject.subjectData[1].additionalDetails"></span></td>
            </tr>
            <tr>
                <td class="field-label">Additional Case Details:</td>
                <td class="fieldValue"><span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="rafReportObject.additionalDetails"></span></td>
            </tr>
        </table>
    </div>
</div>
